
import { SeoRenderer } from "../../../common/helpers/seo";

import BattleOfTheHuns from "./battle-of-the-huns";
import defaultSeo from "./defaultSeo";

export default {
    component: BattleOfTheHuns,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        const _lang = lang === "hu" ? "hu" : "en";
        SeoRenderer({
            title: defaultSeo[_lang].title,
            description: defaultSeo[_lang].description,
            image: defaultSeo.image,
            allMessage,
            lang,
        });
    },
};